import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isDropdown(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.DROPDOWN && typeof label === 'string' && typeof value === 'string';
}
function _formatDropdown(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatDropdown(submission) {
  if (isDropdown(submission)) {
    return _formatDropdown(submission);
  }
  return undefined;
}
//# sourceMappingURL=dropdown-preview.js.map